/**
 * 63.4 step 6 (decision 130 (a); ARCHITECTURE §5.13 "63.3 and 63.4, the design"; lane F): a blast on the props. Every
 * tree and rock whose shape lies within the blast's own radius of where it went off (core/hits.ts propsWithin) takes
 * the blow whole — no falloff, as the flora rule always had it — through the damage door, which scales it by the
 * table (constants/damage.ts: a shell fells a tree in a hit, a rocket's burst takes three, rocks stand) and logs it.
 * Pure.
 */
import type { BlowCause } from '../types/body';
import type { GameState, Vec3 } from '../types';
import { applyDamage } from './damage';
import { propsWithin } from './hits';

/** A blast of `amount` and `radius` at `point` on planet `planetIndex`, by `by`, on the props in reach: the state after and the trees it felled. */
export function blastProps(
  state: GameState, planetIndex: number, point: Vec3, radius: number, amount: number, cause: BlowCause, by?: number,
): { state: GameState; felled: number[] } {
  if (planetIndex < 0 || !(amount > 0)) return { state, felled: [] };
  const felled: number[] = [];
  let s = state;
  for (const { ref } of propsWithin(point, radius, planetIndex, state)) {
    if (ref.kind === 'structure' || ref.kind === 'ruin' || ref.kind === 'debris') continue;   // bodies, not props (propsWithin leaves them out); debris takes no blow
    const r = applyDamage(s, { prop: { kind: ref.kind, id: ref.id, from: point } }, amount, cause, by);
    s = r.state;
    if (r.killed) felled.push(ref.id);
  }
  return { state: s, felled };
}
